/**
 * Created by sanchez
 */
'use strict';

//check the environment
if (process.env.NODE_ENV !== 'production') {
  console.log('Looks like we are in development mode!')
}

/****** IMPORT MODULES AND LIBRAIRIES *******/

// import CSS
// import animate_css from 'animate.css/animate.min.css';
//import css from '../styles/css.css';
import scss from '../styles/sass.scss'

import $ from 'jquery'

window.jQuery = $;
window.$ = $;

import 'bootstrap'
import 'jquery-match-height'
import 'slick-carousel'
import '../../../node_modules/slick-carousel/slick/slick-theme.scss'
import '../../../node_modules/slick-carousel/slick/slick.scss'
import '../../../node_modules/flatpickr/dist/flatpickr.min.css'
import '../../../node_modules/flatpickr/dist/themes/airbnb.css'

import flatpickr from 'flatpickr'
import {French} from "flatpickr/dist/l10n/fr.js"

require('webpack-jquery-ui/datepicker');
require('webpack-jquery-ui/css');
jQuery(function ($) {
  $.datepicker.regional['fr'] = {
    closeText: 'Fermer',
    prevText: '&#x3c;Préc',
    nextText: 'Suiv&#x3e;',
    currentText: 'Aujourd\'hui',
    monthNames: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin',
      'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun',
      'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    weekHeader: 'Sm',
    dateFormat: 'dd-mm-yy',
    firstDay: 1,
    isRTL: false,
    // showMonthAfterYear: false,
    yearSuffix: '',
    // minDate: 0,
    // maxDate: '+12M +0D',
    showButtonPanel: true
  };
  $.datepicker.setDefaults($.datepicker.regional['fr'])
});

import 'nouislider'
import wNumb from 'wnumb'
import moment from 'moment'

moment.locale('fr');
// ISO-8601, Europe
moment.updateLocale('fr', {
  week: {
    dow: 1, // First day of week is Monday
    doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
  }
});

/****** READY SCRIPTS *******/
window.onload = function () {
  carousel.init()
  // gallery.init()
};

$(document).ready(function () {
  main_header.sticky();
  matchHeight.init();
  carousel.init();
  gallery.init();
  // product.search_fixed()
  // product.search_slide()
  // product.section_view()
  // product.get_date()
  reserve.onInputCustomPrice();
  // reserve.legend()
  reserve.stage();
  reserve.selected_form();
  reserve.section_view();
  reserve.other_address_select();
  reserve.on_select_departure_date();
  reserve.onSelectBirthDate();
  reserve.onClickCloseConfirmationMineur();
  reserve.onChangePaymentType();
  reserve.onSelectStartDate();
  reserve.onCheckKnowBy();
  // slider.price()
  // slider.other_dest()
  date_manager.init();
  help_bloc.onClickOpen();
  help_bloc.onClickClose();

  navigation.onClickNav();
  navigation.onDropdownClick();
  navigation.onHoverParentItem();
  //
  $(window).on('load', function () {
    matchHeight.init();
    carousel.init()
    // gallery.init()
    // product.filter_month_date(1)
    // product.filter_month_date(2)
  });
  $(window).on('resize', function () {
    matchHeight.init();
    $.fn.matchHeight._update();
    carousel.init()
    // gallery.init()
  });
  $(window).on('orientationchange', function (event) {
    matchHeight.init();
    $.fn.matchHeight._update();
    carousel.init()
    // gallery.init()
  })
});

let util = {
  scrollToTop() {
    let $body = $('html, body');

    let target = $('div').offset().top;
    $body.animate({'scrollTop': target}, 750)
  },
  scrollTopClick($link) {
    /*-- give a link the ability of scrolling to an anchor --*/
    let $body = $('html, body');
    if ($link.length) {

      $link.on('click', function (e) {
        e.preventDefault();
        let $this = $(this);
        let target = $($this.attr('href')).offset().top;
        $body.animate({'scrollTop': target}, 750)
      })
      /*-- give a link the ability of scrolling to an anchor --*/

    }
  },
  onlyUniqueArray(value, index, self) {
    return self.indexOf(value) === index
  },
  add_weeks(dt, n) {
    return new Date(dt.setDate(dt.getDate() + (n * 7)));
  }
};

let date_manager = {
  get_sunday_range: function (startDate, endDate) {
    let dates = [];

    startDate = new Date(startDate);
    endDate = new Date(endDate);

    let currDate = moment(startDate).startOf('day');
    let lastDate = moment(endDate).startOf('day');

    if (currDate.weekday() === 6) {
      dates.push(currDate.clone().format('YYYY-MM-DD'));
    }

    while (currDate.add(1, 'days').diff(lastDate) <= 0) {
      if (currDate.clone().weekday() === 6) {
        dates.push(currDate.clone().format('YYYY-MM-DD'));
      }
    }

    return dates;
  },

  init: function () {
    let nowDate = new Date();
    let minDate = util.add_weeks(new Date(), 2);
    let maxDate = new Date('2100-01-01');
    let startDate = $('input[name="package-start-date"]').val();
    let endDate = $('input[name="package-end-date"]').val();

    if (typeof endDate != 'undefined' && endDate.length == 10) {
      maxDate = new Date(endDate)
    }

    if (typeof startDate != 'undefined' && startDate.length == 10) {
      startDate = new Date(startDate);
      let plusDate = util.add_weeks(nowDate, 2);
      if (startDate < plusDate) {
        minDate = plusDate
      } else {
        minDate = startDate
      }
    }

    let enable_dates = [];
    let active_dates = [];
    let the_date_list = [];
    let range_date = $(document).find('#package-range-date').val();
    if (typeof range_date != 'undefined' && range_date.length > 0) {
      let list_date = range_date.split(';');
      if (list_date.length > 0) {
        for (let i = 0; list_date.length > i; i++) {
          let item = list_date[i];
          let date_range = item.split('--');

          the_date_list = date_manager.get_sunday_range(date_range[0], date_range[1]);

          the_date_list.map(value => {
            active_dates.push(value)
          })
        }
      }
    }

    if (active_dates.length > 0) {
      enable_dates = active_dates;
      maxDate = null
    } else {
      enable_dates = [
        function (date) {
          // return true to disable
          return (date.getDay() === 0);
        }
      ]
    }

    let optional_config = {
      altInput: true,
      altFormat: "d/m/Y",
      dateFormat: "Y-m-d",
      minDate: minDate,
      maxDate: maxDate,
      enable: enable_dates,
      locale: French
    };

    $("#sa-flatpickr").flatpickr(optional_config);


    // $('.sa-datepicker').datepicker({
    //     altField: '.sa-datepicker',
    //     dateFormat: 'dd/mm/yy',
    //     minDate: minDate,
    //     maxDate: maxDate,
    //     beforeShowDay: function (date) {
    //         return [date.getDay() == 0]
    //     }
    // });

    $('.sa-birthday-datepicker').datepicker({
      altField: '.sa-birthday-datepicker',
      dateFormat: 'dd/mm/yy',
    })
  }
};

let menufooter = {
  init: function () {
    let btn = $('.footer__list_title');

    btn.on('click', function (e) {
      e.preventDefault();
      let expand = $(this).attr('aria-expanded');

      if (expand == 'true') {
        $(this).attr('aria-expanded', 'false');
        $(this).removeClass('not-collapsed');
        $(this).addClass('collapsed');
        $(this).removeClass('active');
        $(this).next('.collapse').removeClass('show')
      } else {
        $(this).attr('aria-expanded', 'true');
        $(this).addClass('not-collapsed');
        $(this).removeClass('collapsed');
        $(this).addClass('active');
        $(this).next('.collapse').addClass('show')
      }
    })
  }
};

/****** HOME CAROUSEL *******/

let carousel = {
  add_carousel(el, width, opt = []) {
    if (el !== 'undefined') {

      opt['dots'] = true;
      opt['infinite'] = true;
      opt['speed'] = 800;
      opt['slidesToShow'] = 1;

      if (el.hasClass('adp-h')) {
        // console.log('slick H')
        opt['centerMode'] = true;
        opt['adaptiveHeight'] = true
      } else if (el.hasClass('adp-w')) {
        // console.log('slick W')
        opt['centerMode'] = true;
        opt['variableWidth'] = true
      }

      if (el.hasClass('adp-md-2')) {
        opt['slidesToShow'] = 2;
        opt['responsive'] = [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 1
            }
          }
        ]
      }

      if (el.hasClass('sj-slide-4s')) {
        opt['autoplaySpeed'] = 4000
      }
      if (el.hasClass('sj-slide-5s')) {
        opt['autoplaySpeed'] = 5000
      }
      if (el.hasClass('sj-slide-6s')) {
        opt['autoplaySpeed'] = 6000
      }
      if (el.hasClass('sj-slide-8s')) {
        opt['autoplaySpeed'] = 8000
      }
      if (el.hasClass('sj-slide-10s')) {
        opt['autoplaySpeed'] = 10000
      }
      if (el.hasClass('sj-slide-auto')) {
        opt['autoplay'] = true;
        opt['autoplaySpeed'] = 3000
      }

      if (el.hasClass('sj-slide-fade')) {
        opt['fade'] = true;
        opt['cssEase'] = 'ease-in-out'
      }

      if (el.hasClass('no-dots')) {
        opt['dots'] = false
      }

      if (el.hasClass('slide-xl-5')) {
        if (width > 992) {
          opt['slidesToShow'] = 5;
          opt['slidesToScroll'] = 2
        }
        opt['responsive'] = [
          {
            breakpoint: 1280,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 765,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
      if (el.hasClass('slide-xl-4')) {
        // console.log('slidexl4 active')
        if (width > 992) {
          opt['slidesToShow'] = 4;
          opt['slidesToScroll'] = 2
        }
        opt['responsive'] = [
          {
            breakpoint: 1280,
            settings: {
              arrows: false,
              slidesToShow: 4,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 765,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
      if (el.hasClass('slide-xl-3')) {
        if (width > 992) {
          opt['slidesToShow'] = 3;
          opt['slidesToScroll'] = 1
        }
        opt['responsive'] = [
          {
            breakpoint: 1280,
            settings: {
              arrows: false,
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 765,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true
            }
          }
        ]
      }
      if (el.hasClass('slide-lg-4') && width < 992) {
        opt['slidesToShow'] = 4;
        opt['slidesToScroll'] = 4;
        opt['responsive'] = [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              slidesToShow: 4
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              arrows: false,
              slidesToShow: 1
            }
          }
        ]
      }
      if (el.hasClass('slide-lg-3') && width < 992) {
        opt['slidesToShow'] = 3;
        opt['slidesToScroll'] = 3
      }
      if (el.hasClass('slide-lg-2') && width < 992) {
        opt['slidesToShow'] = 2;
        opt['slidesToScroll'] = 2;
        opt['responsive'] = [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              slidesToShow: 1
            }
          }
        ]
      }
      if (el.hasClass('slide-md-3') && width < 768) {
        opt['slidesToShow'] = 3;
        opt['slidesToScroll'] = 3;
        opt['responsive'] = [
          {
            breakpoint: 576,
            settings: {
              arrows: false,
              slidesToShow: 1
            }
          }
        ]
      }
      if (el.hasClass('slide-md-2') && width < 768) {
        opt['slidesToShow'] = 2;
        opt['slidesToScroll'] = 2
      }
      if (el.hasClass('slide-sm-2') && width < 576) {
        opt['slidesToShow'] = 2;
        opt['slidesToScroll'] = 2

      }

      // console.log(width, opt)
      el.slick({...opt})
    }
  },
  rm_carousel(el, width) {
    if (el !== 'undefined') {
      let slick = el.slick('getSlick');
      console.log('getSlick slide:', slick);
      if (slick) {
        console.log('unslick slide');
        el.slick('unslick')
      }
    }
  }
  ,
  do_carousel(el, width) {
    let _el = {},
      diff = 0;

    if (!el.hasClass('slick-initialized')) {
      if (width < 576 - diff && el.hasClass('sj-slide-sm')) {
        _el = el;
        carousel.add_carousel(_el, width)
        // console.log('slick-sm')
      } else if (width < 768 - diff && el.hasClass('sj-slide-md')) {
        _el = $(document).find('.sj-slide.sj-slide-md');
        carousel.add_carousel(_el, width)
        // console.log('slick-md')
      } else if (width < 992 - diff && el.hasClass('sj-slide-lg')) {
        _el = $(document).find('.sj-slide.sj-slide-lg');
        carousel.add_carousel(_el, width)
        // console.log('slick-lg')
      } else if (width > 992 - diff && el.hasClass('sj-slide-xl')) {
        _el = $(document).find('.sj-slide.sj-slide-xl');
        carousel.add_carousel(_el, width)
        // console.log('slick-xl')
      } else {
        if (el.hasClass('sj-slide-full')) {
          carousel.add_carousel(el, width)
        }
      }
    } else {
      if (width > 576 - diff && el.hasClass('sj-slide-sm')) {
        _el = el;
        carousel.rm_carousel(_el, width)
        // console.log('remove slick-sm')
      } else if (width > 768 - diff && el.hasClass('sj-slide-md')) {
        _el = $(document).find('.sj-slide.sj-slide-md');
        carousel.rm_carousel(_el, width)
        // console.log('remove slick-md')
      } else if (width > 992 - diff && el.hasClass('sj-slide-lg')) {
        _el = $(document).find('.sj-slide.sj-slide-lg');
        carousel.rm_carousel(_el, width)
        // console.log('remove slick-lg')
      } else if (width > 1280 - diff && el.hasClass('sj-slide-xl')) {
        _el = $(document).find('.sj-slide.sj-slide-xl');
        carousel.rm_carousel(_el, width)
        // console.log('remove slick-xl')
      }
    }
  }
  ,
  init() {
    let h_carousel = $(document).find('.sj-slide'),
      h_c_nb = h_carousel.length,
      w_w = $(window).width();

    if (h_c_nb) {
      h_carousel.each(function (i, el) {
        carousel.do_carousel($(el), w_w)
      })
    }
  }
};

/**
 * Gallery slide
 */

let gallery = {
  init() {
    $('.sj-gallery').slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      speed: 700,
      adaptiveHeight: true,
      variableWidth: true,
      centerMode: true,
      arrows: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
          }
        },
        {
          breakpoint: 765,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: true,
            dots: true
          }
        },
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true
          }
        },
      ]
    })
  }
};

/****** Navigation HEADER *******/

let navigation = {
  onDropdownClick() {
    let btn = $(document).find('#sideNavMenu .content-link-dropdown .item-dropdown');

    btn.on('click', function (e) {
      e.preventDefault();
      console.log('clicb dropdocn');
      let block = $(this).parent('.content-link-dropdown');
      block.toggleClass('menu-close')
    })
  },
  onClickNav() {
    let btn = $(document).find('.header-mobile__burger, .header__burger');
    let closeBtn = $(document).find('#sideNavMenu .closebtn');
    let closeOverlay = $(document).find('#menu-overlay');

    btn.on('click', function (e) {
      e.preventDefault();
      navigation.openNav()
    });
    closeBtn.on('click', function (e) {
      e.preventDefault();
      navigation.closeNav()
    });
    closeOverlay.on('click', function (e) {
      e.preventDefault();
      navigation.closeNav()
    })
  },
  closeNav() {
    document.getElementById('menu-overlay').classList.remove('open');
    document.getElementById('sideNavMenu').classList.remove('menu-open')
  },
  openNav() {
    document.getElementById('menu-overlay').classList.add('open');
    document.getElementById('sideNavMenu').classList.add('menu-open')
  },
  onHoverParentItem() {
    let item = $(document).find('#sideNavMenu .block-menu-list .block-menu-link.parent-item');

    item.on('mouseenter click', function (event) {
      let submenu = $(this).find('~ .block-menu-list-child');
      let allSubMenu = $(document).find('.block-menu-list-child');
      allSubMenu.removeClass('open animated fadeInRight');

      if (submenu.length > 0) {
        submenu.addClass('open animated fadeInRight')
      }
    })
  }
};

/****** STICKY HEADER *******/

let main_header = {
  sticky() {
    let lastScrollTop = 0;

    $(window).scroll(function (event) {
      const st = $(this).scrollTop();
      const header = $('#main-header');
      const headerPos = $('#main-header').scrollTop();
      const bg_home = $('.bg-home');
      const help_bloc = $('.help-bloc');

      if (st > lastScrollTop) {
        //scroll down
        if (st >= 75) {
          header.addClass('hidden');
          header.addClass('header--sticky');
          bg_home.addClass('bg-home__mini');
          help_bloc.addClass('sticky')
          //header.removeClass('sticky');
        }
      } else {
        //scroll up
        if (st <= 10 && header.hasClass('header--sticky')) {
          header.removeClass('header--sticky');
          help_bloc.removeClass('sticky');
          bg_home.removeClass('bg-home__mini')
        } else if (st > 10) {
          header.addClass('header--sticky');
          help_bloc.addClass('sticky');
          bg_home.addClass('bg-home__mini')
        }
        header.removeClass('hidden')
      }

      lastScrollTop = st
    })
  }
};

/****** SLIDER JS *******/

let slider = {
  price() {
    let el = document.getElementById('slide-price');
    let p_min = $(document).find('#sj-search-min-price');
    let p_max = $(document).find('#sj-search-max-price');

    if (el) {
      noUiSlider.create(el, {
        start: [300, 4000],
        tooltips: true,
        step: 5,
        behaviour: 'drag-tap',
        connect: true,
        range: {
          'min': [50],
          'max': [10000]
        },
        format: wNumb({
          decimals: 0,
          thousand: ' ',
          suffix: ' €',
        })
      });

      el.noUiSlider.on('change', function () {
        let price = el.noUiSlider.get();
        // console.log(price)

        p_min.val(price[0].replace(' €', '').replace(' ', ''));
        p_max.val(price[1].replace(' €', '').replace(' ', ''))
      })
    }
  },
  other_dest() {
    let btn = $('#sj-other-dest');
    let block = $('.h-dest.other-dest');

    btn.on('click', function (e) {
      e.preventDefault();

      if (block.hasClass('slide-h')) {
        block.removeClass('slide-h')
      } else {
        block.addClass('slide-h')
      }
    })
  }
};

/****** MATCH HEIGHT *******/

let matchHeight = {
  init() {
    $(function () {
        $('.m-ht').matchHeight();
        $('.m-ht-1').matchHeight();
        $('.m-ht-2').matchHeight();
        $('.m-ht-3').matchHeight()
      }
    )
  }
};

/****** RESERVE JS *******/

let reserve = {
  getPaymentType(slug) {
    if (slug === 'cb') {
      return 'Carte bancaire'
    }
    if (slug === 'vb') {
      return 'Virement bancaire'
    }
    if (slug === 'cheque') {
      return 'Chèque'
    }
    return ''
  },
  onChangePaymentType() {
    $('[name="payment-type"]').on('change', function () {
      let slug = $(this).val();
      let type = reserve.getPaymentType(slug);

      $('#popupReservationCompleted').find('.payment-type').text(' ' + type)
    })
  },
  parseUserInformation() {
    let form = $('#sj-reserve-form');
    let name = form.find('[name="name"]').val();
    let firstname = form.find('[name="firstname"]').val();

    $('#popupReservationCompleted').find('.p-user').text(' ' + firstname + ' ' + name)
  },
  onSelectBirthDate() {
    let input = $('.sa-birthday-datepicker');

    input.on('change', function () {
      let value = input.val();
      let date = moment(value, 'DD/MM/YYYY');
      let date_now = moment();
      let ms = date_now.diff(date);
      let duration = moment.duration(ms);

      if (duration.years() < 16) {
        $('#confirmMineur').modal('show')
      }
    })
  },
  onClickCloseConfirmationMineur() {
    let btn = $('#confirmMineur .close');
    let input = $('.sa-birthday-datepicker');

    btn.on('click', function () {
      let checkbox = $(document).find('#confirmationMineurCheck');
      if (!checkbox.is(':checked')) {
        input.val('')
      }
    })
  },
  onInputCustomPrice() {
    let input = $('#s-form-price-type-custom-value');
    const SAJ_ACOMPTE_PRICE = 101;

    input.on('input', function () {
      let input_value = parseFloat(input.val());
      if (input_value < SAJ_ACOMPTE_PRICE) {
        input.val(SAJ_ACOMPTE_PRICE)
      }
    })
  },

  onSelectStartDate() {
    let input = $('#sj-reserve-form input[name="date-departure"]');

    input.on('change', function () {
      let value = input.val();
      let date = moment(value, 'YYYY-MM-DD');
      let date_now = moment();
      let ms = date.diff(date_now, 'weeks');
      let field = $('#billing-price-manager .accompte-field');

      if (ms < 4) {
        field.addClass('d-none');
        field.find('input').prop('checked', false)
      } else {
        field.removeClass('d-none')
      }
    })
  },

  legend() {
    let btn = $(document).find('.p-reserve .legend .legend__link');

    btn.on('click', function (e) {
      e.preventDefault();

      let btn_data = parseInt($(this).attr('data-stage'));

      if (btn_data) {
        reserve.goToStage(btn_data)
      }
    })
  },

  validateEach(elements, stage = 0) {
    let error = 0;

    if (elements.length > 0) {
      elements.each(function (i, el) {
        $(this).removeClass('error');
        $(this).parent().removeClass('error')
      });

      elements.each(function (i, el) {
        let _this = $(this);
        let value = _this.val();

        if (_this.attr('type') === 'checkbox') {
          if (!_this.is(':checked')) {
            _this.parent().addClass('error');
            error++
          }
        }

        if (value.length < 1) {
          _this.addClass('error');
          error++
        }
      });

      if (error > 0) {
        if (stage !== 0) {
          $(document).find('.stage-' + stage + ' .error-msg').addClass('view')
        } else {
          $(document).find('.stage .error-msg').addClass('view')
        }
        return false
      } else {
        // console.log('all ok in this stage')
        return true
      }
    }
  },

  goToStage(stage) {
    if (stage !== 'undefined') {
      let legend = $(document).find('.p-reserve .legend .legend__link');
      let section = $(document).find('.p-reserve .stage');
      let next_legende = $(document).find('.p-reserve .legend .legend__link.btn-stage-' + stage);

      //section.fadeOut(400)
      section.removeClass('active');
      legend.parent('.legend__item').removeClass('active');

      next_legende.parent('.legend__item').addClass('active');
      //$(document).find(".p-reserve .stage-" + stage).addClass('active').fadeIn(800)
      $(document).find('.p-reserve .stage-' + stage).addClass('active');

      // util.scrollToTop()

      $('body,html').animate({
        scrollTop: 0
      }, 600);

      reserve.parseUserInformation()
    }
  },

  check_form_info(form_data) {
    let form = $(document).find('#sj-reserve-form');
    let opts = $(document).find('.stage-1 .sjr-1-opt');

    let revision_travel = $('#user-revision-travel');
    let revision_options = $('#user-revision-options');
    let revision_product = $('#user-revision-product');
    let revision_info = $('#user-revision-info');
    let revision_safe = $('#user-revision-safe');
    let revision_contact = $('#user-revision-contact');
    let revision_billing = $('#user-revision-billing');

    let lesson = $(document).find('#sj-reserve-form [name="lesson"]');
    let housing = $(document).find('#sj-reserve-form [name="housing"]');
    let housing_text = '';
    let service_um = $(document).find('#sj-reserve-form [name="service-um[]"]');
    let insurance = $(document).find('#sj-reserve-form [name="insurance[]"]');
    let transfert = $(document).find('#sj-reserve-form [name="transfert"]');
    let transfert_text = '';
    let destination = $(document).find('#sj-reserve-form [name="destination"]');
    let init_week = $(document).find('#sj-reserve-form [name="package-init-week-number"]');
    let week_supp = $(document).find('#sj-reserve-form [name="week-supp"]');

    let init_week_nb = parseInt(init_week.val());
    let week_supp_nb = parseInt(week_supp.val());
    let company = '';
    let service_um_checked = '';
    let service_um_checked_recap = '';
    let insurance_checked = '';
    let insurance_checked_recap = '';
    let total_week = 0;

    if (!isNaN(init_week_nb)) {
      total_week = init_week_nb;
      if (!isNaN(week_supp_nb)) {
        total_week = total_week + week_supp_nb
      }
    }

    if (typeof housing !== 'undefined' && housing.length > 0) {
      housing_text = housing.find('option:selected').text()
    } else {
      housing_text = $(document).find('#sj-reserve-form [name="package-housing-text"]').val()
    }
    if (typeof transfert !== 'undefined' && transfert.length > 0) {
      transfert_text = transfert.find('option:selected').text()
    } else {
      transfert_text = $(document).find('#sj-reserve-form [name="package-transfert-text"]').val()
    }

    function getRadioSelected(value) {
      if (value === 'no') {
        return 'Non'
      } else if (value === 'yes') {
        return 'Oui'
      } else if (value === 'other') {
        return 'Peu importe'
      }
    }

    insurance.each(function (i, el) {
      if (el.checked === true) {
        insurance_checked += '<li>' + el.title + '</li>';
        insurance_checked_recap += '<li><span>' + el.title + ': </span><span>Oui</span></li>'
      } else {
        insurance_checked_recap += '<li><span>' + el.title + ': </span><span>Non</span></li>'
      }
    });
    service_um.each(function (i, el) {
      if (el.checked === true) {
        service_um_checked += '<li>' + el.title + '</li>';
        service_um_checked_recap += '<li><span>' + el.title + ': </span><span>Oui</span></li>'
      } else {
        service_um_checked_recap += '<li><span>' + el.title + ': </span><span>Non</span></li>'
      }
    });

    if (form_data !== undefined) {
      let infos = [];

      form_data.forEach(function (el, i) {
        infos[el.name] = el.value
      });

      let opts_nb = 0;

      opts.each(function (i, el) {
        if ($(this).is(':checked')) {
          let val = $(this).val();
          val = val.split('-');
          let _title = $(document).find('#sjr-1-opt-title-' + val[0]);
          let _unity = $(document).find('#sjr-1-opt-unity-' + val[0]);

          let title = _title.val();
          let unity = _unity.val();
          let value = parseInt(val[1]);

          elm3.append(title);
          opts_nb++
        }
      });

      if (opts_nb < 0) {
        d;
        elm3.empty();
        elm3.append('<p>Vous n\'avez pas sélectionné d\'options.</p>')
      }

      // console.log(infos)

      revision_travel.empty();
      revision_travel.append(
        '<ul>' +
        '<li>Du ' + infos['date-departure'] + ' au ' + infos['date-return'] + '</li>' +
        '<li>' + lesson.find('option:selected').text() + '</li>' +
        '<li><span>Type de cours :</span><span> ' + infos['package-lesson-type'] + '</span></li>' +
        '<li>' + housing_text + '</li>' +
        '<li><span>Centre(s) :</span><span>' + infos['package-center'] + '</span></li>' +
        '</ul>'
      );

      revision_options.empty();
      revision_options.append(
        '<span class="info-title">Options</span>' +
        '<ul>' +
        insurance_checked +
        service_um_checked +
        transfert_text +
        '</ul>'
      );

      let insurance_cancel = infos['insurance-cancel'] ? 'Oui' : '';

      revision_product.empty();
      revision_product.append(
        '<ul>' +
        '<li><span>Séjour: </span><span>' + infos['package-name'] + '</span></li>' +
        '<li><span>Date d\'arrivée: </span><span>' + infos['date-arrival'] + '</span/li>' +
        '<li><span>Date de retour: </span><span>' + infos['date-return'] + '</span/li>' +
        '<li><span>Durée du séjour: </span><span>' + total_week + ' semaine(s)</span></li>' +
        '<li><span>Rythme: </span><span>' + lesson.find('option:selected').text() + '</span></li>' +
        '<li><span>Destination: </span><span>' + destination.find('option:selected').text() + '</span></li>' +
        '<li><span>Hébergement: </span><span>' + housing_text + '</span></li>' +
        '<li><span>Transfert: </span><span>' + transfert_text + '</span></li>' +
        insurance_checked_recap +
        service_um_checked_recap +
        '</ul>'
      );

      revision_info.empty();
      revision_info.append(
        '<span class="product-info-title">Mes informations</span>' +
        '<ul>' +
        '<li><span>Civilité: </span><span>' + infos['civility'] + '</span></li>' +
        '<li><span>Nom et prénom: </span><span>' + infos['firstname'] + ' ' + infos['name'] + '</span></li>' +
        '<li><span>Date de naissance: </span><span>' + infos['birthday'] + '</span></li>' +
        '<li><span>Langues maternelle: </span><span>' + infos['language'] + '</span></li>' +
        '<li><span>Niveau de langue: </span><span>' + infos['language-level'] + '</span></li>' +
        '</ul>'
      );

      revision_safe.empty();
      revision_safe.append(
        '<span class="product-info-title">Personne à contacter</span>' +
        '<ul>' +
        '<li><span>Nom et prénom du contat: </span><span>' + infos['safe-firstname'] + ' ' + infos['safe-name'] + '</span></li>' +
        '<li><span>Tél portable du contact: </span><span>' + infos['safe-phone'] + '</span></li>' +
        '</ul>'
      );

      revision_contact.empty();
      revision_contact.append(
        '<span class="product-info-title">Contact et adresse</span>' +
        '<ul>' +
        '<li><span>Adresse: </span><span>' + infos['address-1'] + '  ' + infos['address-2'] + '</span></li>' +
        '<li><span>Code postal: </span><span>' + infos['postcode'] + '</span></li>' +
        '<li><span>Ville: </span><span>' + infos['city'] + '</span></li>' +
        '<li><span>Pays: </span><span>' + infos['country'] + '</span></li>' +
        '<li><span>Email: </span><span>' + infos['email'] + '</span></li>' +
        '<li><span>Tél portable: </span><span>' + infos['phone'] + '</span></li>' +
        '<li><span>Tél privé: </span><span>' + infos['phone-2'] + '</span></li>' +
        '</ul>'
      );

      if (infos['user-type'] === 'company') {
        company = 'Entreprise'
      }
      if (infos['user-type'] === 'private') {
        company = 'Privé/particulier'
      }

      if (infos['billing-check-address'] === 'other') {
        revision_billing.empty();
        revision_billing.append(
          '<span class="product-info-title">Facturation</span>' +
          '<ul>' +
          '<li><span>Type: </span><span>' + company + '</span></li>' +
          '<li><span>Civilité: </span><span>' + infos['billing-civility'] + '</span></li>' +
          '<li><span>Nom et prénom: </span><span>' + infos['billing-firstname'] + ' ' + infos['billing-name'] + '</span></li>' +
          '<li><span>Adresse: </span><span>' + infos['billing-address-1'] + ' - ' + infos['billing-address-2'] + '</span></li>' +
          '<li><span>Code postal: </span><span>' + infos['billing-postcode'] + '</span></li>' +
          '<li><span>Ville: </span><span>' + infos['billing-city'] + '</span></li>' +
          '<li><span>Pays: </span><span>' + infos['billing-country'] + '</span></li>' +
          '<li><span>Email: </span><span>' + infos['billing-email'] + '</span></li>' +
          '<li><span>Tél portable: </span><span>' + infos['billing-phone'] + '</span></li>' +
          '<li><span>Tél privé: </span><span>' + infos['billing-phone-2'] + '</span></li>' +
          '</ul>'
        )
      } else {
        revision_billing.empty();
        revision_billing.append(
          '<span class="product-info-title">Facturation</span>' +
          '<ul>' +
          '<li><span>Civilité: </span><span>' + infos['civility'] + '</span></li>' +
          '<li><span>Nom et prénom: </span><span>' + infos['firstname'] + ' ' + infos['name'] + '</span></li>' +
          '<li><span>Adresse: </span><span>' + infos['address-1'] + ' - ' + infos['address-2'] + '</span></li>' +
          '<li><span>Code postal: </span><span>' + infos['postcode'] + '</span></li>' +
          '<li><span>Ville: </span><span>' + infos['city'] + '</span></li>' +
          '<li><span>Pays: </span><span>' + infos['country'] + '</span></li>' +
          '<li><span>Email: </span><span>' + infos['email'] + '</span></li>' +
          '<li><span>Tél portable: </span><span>' + infos['phone'] + '</span></li>' +
          '<li><span>Tél privé: </span><span>' + infos['phone-2'] + '</span></li>' +
          '</ul>'
        )
      }
    }
  },

  roller_action(value) {
    let checkbox = $('#s-form-billing-other-address');
    let checkbox2 = $('#s-form-billing-check-address');
    let roller = $('#custom-other-billing-address');

    if (value > 0) {
      roller.removeClass('roller-close');
      roller.find('input, select').each(function (i, el) {
        if (!$(this).hasClass('no-required')) {
          $(this).addClass('required');
          $(this).attr('required', 'required')
        }
      });
      checkbox2.removeAttr('checked', 'checked')
    } else {
      roller.addClass('roller-close');
      roller.find('input, select').each(function (i, el) {
        $(this).removeClass('required');
        $(this).removeAttr('required', 'required')
      });
      checkbox2.attr('checked', 'checked')
    }
  },

  roller_checker() {
    let checkbox = $('#s-form-billing-other-address');
    if ($(document).find('#s-form-billing-other-address:checked').length > 0) {
      checkbox.removeAttr('checked', 'checked')
    } else {
      checkbox.attr('checked', 'checked')
    }
  },

  other_address_select() {
    let checkbox = $('#s-form-billing-other-address');
    let checkbox2 = $('#s-form-billing-check-address');
    let radioPrice = $('#billing-price-manager');

    checkbox.on('change', function () {
      reserve.roller_action($(document).find('#s-form-billing-other-address:checked').length);
      reserve.roller_checker()
    });

    checkbox2.on('change', function () {
      reserve.roller_checker();
      reserve.roller_action($(document).find('#s-form-billing-other-address:checked').length)
    });

    radioPrice.find('input').on('change', function () {
      let field = $('.product-total-pride-custom');
      if ($(document).find('#s-form-price-type-custom:checked').length > 0) {
        field.removeClass('roller-close');
        $(document).find('#s-form-price-type-custom-value').attr('required', 'required').addClass('required')
      } else {
        field.addClass('roller-close');
        $(document).find('#s-form-price-type-custom-value').removeAttr('required').removeClass('required')
      }
    })
  },

  onCheckKnowBy() {
    let check = $(document).find('[name="knowby-ear"],[name="knowby-ad"],[name="knowby-engine"],[name="knowby-other"]');
    let checker = $(document).find('input[name="knowby"]');

    checker.on('change', function (e) {
      let checkerValue = $(this).val();
      console.log('checkval:', checkerValue);
      if (checkerValue) {
        let selectedChecker = $(document).find('input[name="knowby-' + checkerValue + '"');
        console.log('checkEL:', 'knowby-' + checkerValue);
        console.log('selectedChecker:', selectedChecker);
        if (selectedChecker) {
          check.removeClass('required');
          check.removeClass('error');
          check.removeAttr('required');
          selectedChecker.addClass('required');
          selectedChecker.attr('required', 'required')
        }
      }
    })
  },

  stage() {
    let legend = $(document).find('.p-reserve .legend .legend__link');
    let section = $(document).find('.p-reserve .stage');
    let form = $(document).find('#sj-reserve-form');

    let btn_1 = $(document).find('#sjr-1-btn');
    let btn_2 = $(document).find('#sjr-2-btn');
    let btn_2_2 = $(document).find('#sjr-2-btn-2');
    let btn_3 = $(document).find('#sjr-3-btn');
    let btn_3_2 = $(document).find('#sjr-3-btn-2');
    let btn_4 = $(document).find('#sjr-4-btn');

    btn_1.on('click', function (e) {
      e.preventDefault();
      let field = $(document).find('.stage-1 .required');

      $(document).find('.stage-1 .error-msg').removeClass('view');

      if (field.length > 0) {
        let valid = reserve.validateEach(field, 1);

        if (valid) {
          let form_data = form.serializeArray();

          reserve.check_form_info(form_data);
          reserve.goToStage(2)
        }
      }
    });

    btn_2.on('click', function (e) {
      e.preventDefault();
      let field = $(document).find('.stage-2 .required');

      $(document).find('.stage-2 .error-msg').removeClass('view');

      if (field.length > 0) {
        let valid = reserve.validateEach(field, 2);

        if (valid) {
          let form_data = form.serializeArray();

          reserve.check_form_info(form_data);
          reserve.goToStage(3)
        }
      }
    });

    btn_3.on('click', function (e) {
      e.preventDefault();

      e.preventDefault();
      let field = $(document).find('.stage-3 .required');
      $(document).find('.stage-3 .error-msg').removeClass('view');
      if (field.length > 0) {
        let valid = reserve.validateEach(field, 3);

        if (valid) {
          reserve.goToStage(4)
        }
      }
    });

    btn_2_2.on('click', function (e) {
      e.preventDefault();

      reserve.goToStage(1)
    });

    btn_3_2.on('click', function (e) {
      e.preventDefault();

      reserve.goToStage(2)
    });

    btn_4.on('click', function (e) {
      e.preventDefault();

      let field = $(document).find('.stage-4 .required');

      $(document).find('.stage-4 .error-msg').removeClass('view');

      if (field.length > 0) {
        let valid = reserve.validateEach(field, 4);

        if (valid) {
          // reserve.goToStage(5)
          form.find('#package-validation-input').val(1);
          form.find('#package-validation-input').trigger('change')
        }
      }
    })
  },

  selected_form() {
    let form = $(document).find('#sj-reserve-form'),
      init_price = form.find('.sj-init-price').val(),
      asur = $(document).find('#sjr-1-assurance'),
      um = $(document).find('#sjr-1-sum'),
      asur_price = 0,
      um_price = 0,
      total_price = init_price;

    if (asur.length > 0) {
      asur_price = asur.val();

      asur.on('change', function () {
        // console.log($(document).find('#sjr-1-assurance:selected'))
        if ($(document).find('#sjr-1-assurance:selected')) {
          total_price = total_price + asur_price
        }
      })
    }
    if (um.length > 0) {
      um_price = um.val();
      um.on('change', function () {
        // console.log($(document).find('#sjr-1-sum:selected'))
        if ($(document).find('#sjr-1-sum:selected')) {
          total_price = total_price + um_price
        }
      })
    }

    // console.log('total_price : ', total_price)
  },

  section_view() {
    let btn = $('#bcmd-select .bcmd-item');
    let section = $('#bcmd-container');

    btn.on('click', function (e) {
      e.preventDefault();

      let _this = $(this);
      let btn_data = $(this).attr('data-cmd');
      let s_view = section.find('.' + btn_data);

      if (s_view.length) {
        btn.removeClass('active');
        $('#bcmd-select .bcmd-item').removeClass('active');
        _this.addClass('active');

        section.find('> div').addClass('post-active');
        setTimeout(function () {
          section.find('> div').removeClass('active');
          s_view.addClass('post-active');
          s_view.addClass('active')
        }, 400);
        setTimeout(function () {
          s_view.removeClass('post-active')
        }, 550)
      }
    })
  },

  make_dates_composer() {
    let departure = $('#sj-reserve-form input[name="date-departure"]');
    let return_field = $('#sj-reserve-form input[name="date-return"]');
    let return_arrival = $('#sj-reserve-form input[name="date-arrival"]');
    let day_return = $('#package-day-return');
    let week_supp = parseInt($('#sj-reserve-form select[name="week-supp"]').val());
    let init_week = parseInt($('#sj-reserve-form input[name="package-init-week-number"]').val());
    let nb_day_in_week = parseInt($('#sj-reserve-form input[name="package-day-in-week"]').val());
    let week_nbr = 0;
    let week_day_nbr = 6;
    let day_return_val = 'saturday';

    // if (nb_day_in_week !== 0) {
    //   week_day_nbr = nb_day_in_week;
    // }

    if (day_return.val() == 'sunday') {
      week_day_nbr = 7;
    }

    if (day_return.val() == 'saturday') {
      week_day_nbr = 6;
    }

    if (week_supp > 0) {
      week_nbr = week_supp + init_week
    } else {
      week_nbr = init_week
    }

    let return_date = reserve.get_returned_date(departure.val(), week_nbr, week_day_nbr);
    let arrival_day = moment(departure.val(), 'YYYY-MM-DD');

    return_arrival.val(arrival_day.format('DD/MM/YYYY'));
    return_field.val(return_date)
  },

  on_select_departure_date() {
    let departure = $('#sj-reserve-form input[name="date-departure"]');
    let week_supp = $('#sj-reserve-form select[name="week-supp"]');

    departure.on('change', function () {
      reserve.make_dates_composer()
    });
    week_supp.on('change', function () {
      reserve.make_dates_composer()
    })
  },

  get_returned_date(departure, week_number, week_day) {
    let all_day = 0;

    let m_day = moment(departure, 'YYYY-MM-DD');
    week_number = parseInt(week_number);

    if (week_day < 7) {
      all_day = (7 * week_number) - 1
    } else {
      all_day = 7 * week_number
    }

    return m_day.clone().add(all_day, 'day').format('DD/MM/YYYY')
  },
};

let help_bloc = {
  onClickOpen() {
    let btn = $('.help-bloc-open');

    btn.on('click', function (e) {
      e.preventDefault();

      let picto_bloc = $('.help-bloc-picto');
      let help_bloc = $('.help-bloc');
      picto_bloc.addClass('close-block');
      help_bloc.addClass('open-block')
    })
  },
  onClickClose() {
    let btn = $('.help-left-close ');

    btn.on('click', function (e) {
      e.preventDefault();

      let picto_bloc = $('.help-bloc-picto');
      let help_bloc = $('.help-bloc');
      picto_bloc.removeClass('close-block');
      help_bloc.removeClass('open-block')
    })
  }
};

// import Js Plugins/Entities

//ES6 Module
//import Bar1 from './entities/Bar1';

//CommonJS
//let Bar2 = require('./entities/Bar2');

// window.h5 = {
//     isPc: function () {
//         var userAgentInfo = navigator.userAgent
//         var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
//         var flag = true
//         for (var v = 0; v < Agents.length; v++) {
//             if (userAgentInfo.indexOf(Agents[v]) > 0) {
//                 flag = false
//                 break
//             }
//         }
//         return flag
//     },
//     rootResize: function () {
//         var wFsize
//
//         //iphone6/6s/7/8 orientation=portrait screen.width=750px screen.height=1334px / WeChat window.innerWidth=750px window.innerHeight=1206px
//         var wWidth = (window.screen.width > 0) ? (window.innerWidth >= window.screen.width || window.innerWidth == 0) ? screen.width :
//             window.innerWidth : window.innerWidth
//         var wHeight = (window.screen.height > 0) ? (window.innerHeight >= window.screen.height || window.innerHeight == 0) ?
//             window.screen.height : window.innerHeight : window.innerHeight
//         // var wWidth = window.innerWidth;
//         // var wHeight = window.innerHeight;
//
//         if (wWidth > wHeight) {
//             wFsize = wHeight / 750 * 100
//         } else {
//             wFsize = wWidth / 750 * 100
//         }
//         document.getElementsByTagName('html')[0].style.fontSize = wFsize + 'px'
//     },
//     eventInit: function () {
//         var that = this
//         document.addEventListener('touchstart', function (e) {
//         }, { passive: false })
//         document.addEventListener('touchmove', function (e) {
//             e.preventDefault()
//         }, { passive: false })
//         return that
//     },
//     cssInit: function () {
//         var that = this
//         var noChangeCountToEnd = 100,
//             noEndTimeout = 1000
//         that.rootResize()
//         window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', function () {
//             var interval,
//                 timeout,
//                 end,
//                 lastInnerWidth,
//                 lastInnerHeight,
//                 noChangeCount
//             end = function () {
//                 // "orientationchangeend"
//                 clearInterval(interval)
//                 clearTimeout(timeout)
//                 interval = null
//                 timeout = null
//                 that.rootResize()
//             }
//             interval = setInterval(function () {
//                 if (window.innerWidth === lastInnerWidth && window.innerHeight === lastInnerHeight) {
//                     noChangeCount++
//                     if (noChangeCount === noChangeCountToEnd) {
//                         // The interval resolved the issue first.
//                         end()
//                     }
//                 } else {
//                     lastInnerWidth = window.innerWidth
//                     lastInnerHeight = window.innerHeight
//                     noChangeCount = 0
//                 }
//             })
//             timeout = setTimeout(function () {
//                 // The timeout happened first.
//                 end()
//             }, noEndTimeout)
//         })
//
//         return that
//     },
//     init: function () {
//         var that = this
//         that.cssInit().eventInit()
//     }
// }

//Stats JavaScript Performance Monitor

//import Stats from 'stats.js';
//showStats();
// function showStats() {
//     var stats = new Stats();
//     stats.showPanel(0); // 0: fps, 1: ms, 2: mb, 3+: custom
//     var fs = document.createElement('div');
//     fs.style.position = 'absolute';
//     fs.style.left = 0;
//     fs.style.top = 0;
//     fs.style.zIndex = 999;
//     fs.appendChild(stats.domElement);
//     document.body.appendChild(fs);

//     function animate() {
//         stats.begin();
//         // monitored code goes here
//         stats.end();
//         requestAnimationFrame(animate);
//     }
//     requestAnimationFrame(animate);
// }
